import { useMemo } from 'react';
import { useEmpresa } from '../contexts/EmpresaContext';

const SLUG_LEGADO = 'kzero-consultoria';

// Resolve um valor namespaced por empresa com migração lazy:
// - Se o mapa tem entrada pra essa empresa, usa.
// - Se a empresa é "kzero-consultoria" (histórica) e existe valor legado, usa o legado.
// - Senão, retorna o vazio passado (mantendo referência estável).
export function resolverNamespaceEmpresa(mapaPorEmpresa, slug, legado, vazio) {
  if (mapaPorEmpresa && mapaPorEmpresa[slug] !== undefined) return mapaPorEmpresa[slug];
  if (slug === SLUG_LEGADO && legado !== undefined && legado !== null) return legado;
  return vazio;
}

// Hook: resolve um campo namespaced por empresa e devolve um setter que escreve
// no mapa *PorEmpresa[slug] correto, com fallback retrocompat ao setter legado.
//
// Uso:
//   const [anotacoes, setAnotacoes] = useNamespaceEmpresa({
//     mapaPorEmpresa: anotacoesPorEmpresa, setMapaPorEmpresa: setAnotacoesPorEmpresa,
//     legado: anotacoesLegado, setLegado: setAnotacoesLegado,
//     vazio: EMPTY_ARR,
//   });
export function useNamespaceEmpresa({ mapaPorEmpresa, setMapaPorEmpresa, legado, setLegado, vazio }) {
  const { empresaAtiva } = useEmpresa();
  const slugEmp = empresaAtiva?.slug || SLUG_LEGADO;

  const valor = useMemo(
    () => resolverNamespaceEmpresa(mapaPorEmpresa, slugEmp, legado, vazio),
    [mapaPorEmpresa, slugEmp, legado, vazio]
  );

  const setValor = (valorOuFn) => {
    if (!setMapaPorEmpresa) {
      setLegado?.(valorOuFn);
      return;
    }
    setMapaPorEmpresa(prevMapa => {
      const mapa = prevMapa || {};
      const atual = resolverNamespaceEmpresa(mapa, slugEmp, legado, vazio);
      const novo = typeof valorOuFn === 'function' ? valorOuFn(atual) : valorOuFn;
      return { ...mapa, [slugEmp]: novo };
    });
  };

  return [valor, setValor, slugEmp];
}
